export default __webpack_public_path__ + "static/og-6f28dddb534d7194c1b534abc35da1f9.jpg";